import { useStaticQuery, graphql } from "gatsby"

// Helper function to return link type and url
const LinkDetect = (url) => {

    const data = useStaticQuery(
        graphql`
        query {
            allWp {
                edges {
                    node {
                        allSettings {
                            generalSettingsUrl
                        }
                    }
                }
            }
        }
    `)

    const stripProtocol = (url) => {
        let urlStripped = url.replace("https://", "")
        urlStripped = urlStripped.replace("http://", "")
        urlStripped = urlStripped.replace("www.", "")
        urlStripped = urlStripped.replace("cms.", "")
        urlStripped = urlStripped.replace("cms-staging.", "")
        return urlStripped
    } 
    
    const link = []
    const urlStripped = stripProtocol(url)
    const wpUrlStripped = stripProtocol(data.allWp.edges[0].node.allSettings.generalSettingsUrl)

    const first = urlStripped.split("/");

    // urlStripped.indexOf(wpUrlStripped) > -1

    // console.log(first[0])
    // console.log(wpUrlStripped)

    if (first[0] === wpUrlStripped || url.substring(0, 1) === "#" || url.substring(0, 1) === "/") {
        link.type = "internal"
        link.url = urlStripped.replace(wpUrlStripped, '')
    } else {
        link.type = "external"
        link.url = url
    }

    return link
}

export { LinkDetect }